import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import PartidoService from '../../../../services/partido-auth';
import Partido from './partido';


const ListarPartido = () => {


    const [partidos, setPartidos] = useState([]);
    const [arquivo, setArquivo] = useState(false);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [partido, setPartido] = useState("");



    async function fetchPartidoIn() {
        const response = await PartidoService.listar();
        if (response.data.length >= 1) {
            setPartidos(response.data)
            setVazio(false)
        } else {
            setPartidos([])
            setVazio(true)
        }
    }

    const handleEditar = (id) => {
        setPartido(id);
        setEditar(true)
    }


    const handleArquivo = (id) => {
        setPartido(id);
        setArquivo(true)
    }

    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar a Liberação de Recurso?')) {
            await PartidoService.deletar(id)
            alert("Liberação de Recurso deletada com sucesso!")
            fetchPartidoIn();
        }
    }

    useEffect(() => {
        fetchPartidoIn();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/partido/editar/${partido}`} />
        )
    } else if (arquivo) {
        return (
            <Navigate to={`/restrito/partido/arquivo/${partido}`} />
        )
    }
    else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setPartidos={setPartidos}
                        setVazio={setVazio}
                        fetchPartidoIn={fetchPartidoIn}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={1} lg={4}>
                            {partidos.map((partido, index) =>
                                <Partido
                                    fetchPartidoIn={fetchPartidoIn}
                                    partido={partido}
                                    key={index}
                                    editar={handleEditar}
                                    arquivo={handleArquivo}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarPartido;